import { DynamicReportRoutes } from "./dynamicreport-routes";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DynamicReportComponent, AttendanceViewComponent } from "./index";

import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { RouterModule } from "@angular/router";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { StudentModule } from "../student/student.module";
import { AttendanceViewService } from "./attendanceview/attendanceview.service";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { CalendarModule } from "primeng/calendar";
import { ConfirmationService } from "primeng/api";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

@NgModule({
	declarations: [DynamicReportComponent, AttendanceViewComponent],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		BrowserAnimationsModule,
		RouterModule,
		ConfirmDialogModule,
		DialogModule,
		StudentModule,
		CalendarModule,
		SchoolselectorModule,
	],

	providers: [ConfirmationService, AttendanceViewService],
})
export class DynamicReportModule {}
